<div class="template-container" [innerHTML]="body"></div>
